import { render, staticRenderFns } from "./SpecialSpecialtiesTable.vue?vue&type=template&id=3f4c5413&"
import script from "./SpecialSpecialtiesTable.vue?vue&type=script&lang=js&"
export * from "./SpecialSpecialtiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports